import {svgIconWrapper} from '../svg-icon-wrapper';

import ChatgptRegularAi from './chatgpt-regular-ai-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <ChatgptRegularAi {...props} />;
}

SvgComponent.iconName = 'chatgptRegularAi';

export const ChatgptRegularAiIcon = svgIconWrapper(SvgComponent);
